import Section from 'components/base/Section';
import EcomCartSummaryCard from 'components/cards/EcomCartSummaryCard';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import EcomCartTable from 'components/tables/EcomCartTable';
import { defaultBreadcrumbItems } from 'data/commonData';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';
import { CartProduct } from 'redux-state/user/cartSlice';

const Cart = () => {
  const cartItems = useSelector((state: RootState) => state.user.cart.cart);
  return (
    <div className="pt-5 mb-9">
      <Section small className="py-0">
        <h2 className="mb-6">Cart</h2>
        {cartItems.map((item: CartProduct, index: number) => (
          <div key={item.vendorId}>
            <Row className="g-5 mb-5">
              <Col xs={12} lg={8}>
                <EcomCartTable
                  products={item.products}
                  totalAmount={item.totalAmount}
                />
              </Col>
              <Col xs={12} lg={4}>
                <EcomCartSummaryCard
                  totalAmount={item.totalAmount}
                  totalAmountAfterDiscount={
                    item.totalAmountAfterDiscount === 0
                      ? item.totalAmount
                      : item.totalAmountAfterDiscount
                  }
                  // discountAmount={item.coupon?.discountAmount ?? 0}
                  vendorId={item.vendorId}
                />
              </Col>
            </Row>
            {index < cartItems.length - 1 && (
              <hr className="separator separator-dashed text-primary mb-5" />
            )}
          </div>
        ))}
      </Section>
    </div>
  );
};

export default Cart;
